import * as React from 'react';
import * as Redux from 'react-redux';
import { Grid } from '@mui/material';
import ListadoEquiposJuegos from './components/ListadoEquiposJuegos';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import {
  allEquiposJuegosAction,
  setActivoEquiposJuegosAction,
} from './EquiposJuegosAction';
import FormEquiposJuegos from './components/FormEquiposJuegos';
import { ModalComponent } from '../../../widgets';

const EquiposJuegosView = () => {
  const dispatch = Redux.useDispatch();

  const equiposJuegosStore = Redux.useSelector((state) => state.equiposJuegos);

  const [openModalForm, setOpenModalForm] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        {/* <BotonComponent
          click={async () => {
            await setActivoEquiposJuegosAction(dispatch, null);
            setOpenModalForm(true);
          }}
          green
          addIcon
          mr={2}
        /> */}
        <BotonComponent
          click={async () => {
            await setActivoEquiposJuegosAction(dispatch, null);
            await allEquiposJuegosAction(dispatch, equiposJuegosStore.params);
          }}
          disabled={
            equiposJuegosStore.all.length === 0 || equiposJuegosStore.loadingAll
          }
          white
          mt={2}
          ml={2}
          mb={1}
          refreshIcon
          text={
            equiposJuegosStore.loadingAll ? 'Actualizando...' : 'Actualizar'
          }
        />
      </Grid>
      <Grid item md={12}>
        <ListadoEquiposJuegos
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </Grid>
      <ModalComponent
        id="modalFormEquiposJuegos"
        title={`${equiposJuegosStore.activo ? `Editar` : 'Nuevo torneo'}`}
        maxWidth="sm"
        open={openModalForm}
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormEquiposJuegos
          activo={equiposJuegosStore.activo}
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </ModalComponent>
    </Grid>
  );
};

export default EquiposJuegosView;
